import { Fragment } from "react";
import { COMPANY } from "@/lib/content";

const TOKEN = /(\*\*[^*]+\*\*|elevioncarenetworkllc@gmail\.com|\(202\)\s*710-0131)/g;

const renderToken = (t, k) => {
  if (t.startsWith("**")) {
    const inner = t.slice(2, -2);
    return <strong key={k}>{/@|\(202/.test(inner) ? renderToken(inner, `${k}i`) : inner}</strong>;
  }
  if (t.includes("@")) return <a key={k} href={`mailto:${COMPANY.email}`} className="underline font-bold">{t}</a>;
  if (t.startsWith("(202")) return <a key={k} href={COMPANY.phoneHref} className="underline font-bold">{t}</a>;
  return t;
};

export const RichText = ({ text }) => (
  <>
    {String(text || "").split("\n").map((line, i) => (
      <Fragment key={i}>
        {i > 0 && <br />}
        {line.replace(/^\s*[-*]\s+/, "• ").split(TOKEN).filter(Boolean).map((t, j) => renderToken(t, `${i}-${j}`))}
      </Fragment>
    ))}
  </>
);
